import React, { useState } from "react";

const IntegrationReviewDetails = ({ details, onButtonClick }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownMethod, setShowDropdownMethod] = useState(false);
  
  if (!details) {
    return <div>Loading...</div>
  }

  return (
    <div className="mb-6 pt-4">
      <div className="text-sm">
        <div className="text-white">
          <div className="text-lg font-medium">Review Details</div>
          <div>
            Here are the integration details we provided. Click 'Save & Deploy' to save
            the itegration
          </div>

          <div className="mt-2 h-[calc(100vh-230px)] overflow-y-scroll">
            <div className="mt-4 flex py-1">
              <div className="w-1/5 py-2 font-bold">Integration Name:</div>
              <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                {details && details.name}
              </div>
            </div>

            <div className="flex py-1">
              <div className="w-1/5 py-2 font-bold">Description:</div>
              <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                {details && details.description}
              </div>
            </div>

            <div className="flex py-1">
              <div className="w-1/5 py-2 font-bold">Trigger:</div>
              <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                {details && details.triggerDetails && details.triggerDetails.triggerType}
              </div>
            </div>

            {details && details.triggerDetails &&
              (details.triggerDetails.triggerType === "Http Trigger" || details.triggerDetails.triggerType === "Webhook Trigger") &&
              <>
                <div className="flex py-1">
                  <div className="w-1/5 py-2 font-bold">Http Method:</div>
                  <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                    {details.triggerDetails.triggerHttpMethod}
                  </div>
                </div>

                <div className="flex py-1">
                  <div className="w-1/5 py-2 font-bold">
                    Trigger Request Payload Schema:
                  </div>
                  <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                    <pre className="whitespace-pre-wrap break-words">
                      {/* {JSON.stringify(triggerRequestPayloadSchema, null, 2)} */}
                      {details.triggerDetails.triggerRequestSchema}
                    </pre>
                  </div>
                </div>

                <div className="flex py-1">
                  <div className="w-1/5 py-2 font-bold">Trigger Response Schema:</div>
                  <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                    <pre className="whitespace-pre-wrap break-words">
                      {details.triggerDetails.triggerResponseSchema}
                    </pre>
                  </div>
                </div>
              </>
            }

            {details.sourceDetails && details.sourceDetails.sourceType === "REST API" &&
              <>
                <div className="flex py-1">
                  <div className="w-1/5 py-2 font-bold">Source Url:</div>
                  <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                    {details.sourceDetails.restAPISourceUrl}
                  </div>
                </div>

                <div className="flex py-1">
                  <div className="w-1/5 py-2 font-bold">Source Type:</div>
                  <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                    {details.sourceDetails.sourceType}
                  </div>
                </div>

                <div className="flex py-1">
                  <div className="w-1/5 py-2 font-bold">Source Http Method:</div>
                  <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                    {details.sourceDetails.restAPIHttpMethod}
                  </div>
                </div>

                <div className="flex py-1">
                  <div className="w-1/5 py-2 font-bold">
                    Source Request Payload Schema:
                  </div>
                  <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                    <pre className="whitespace-pre-wrap break-words">
                      {/* {JSON.stringify(sourceRequestPayloadSchema, null, 2)} */}
                      {details.sourceDetails.restAPISourceRequestSchema}
                    </pre>
                  </div>
                </div>

                <div className="flex py-1">
                  <div className="w-1/5 py-2 font-bold">
                    Source Response Schema:
                  </div>
                  <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                    <pre className="whitespace-pre-wrap break-words">
                      {/* {JSON.stringify(sourceResponseSchema, null, 2)} */}
                      {details.sourceDetails.restAPISourceResponseSchema}
                    </pre>
                  </div>
                </div>
              </>}


            {details.destinationDetails && details.destinationDetails.destinationType === "REST API" &&
              <>
                <div className="flex py-1">
                  <div className="w-1/5 py-2 font-bold">Destination Type:</div>
                  <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                    {details.destinationDetails.destinationType}
                  </div>
                </div>

                <div className="flex py-1">
                  <div className="w-1/5 py-2 font-bold">Destination Http Method:</div>
                  <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                    {details.destinationDetails.restAPIHttpMethod}
                  </div>
                </div>

                <div className="flex py-1">
                  <div className="w-1/5 py-2 font-bold">
                    Destination Request Payload Schema:
                  </div>
                  <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                    <pre className="whitespace-pre-wrap break-words">
                      {/* {JSON.stringify(destinationRequestPayloadSchema, null, 2)} */}
                      {details.destinationDetails.restAPIDestinationRequestSchema}
                    </pre>
                  </div>
                </div>

                <div className="flex py-1">
                  <div className="w-1/5 py-2 font-bold">
                    Destination Response Schema:
                  </div>
                  <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                    <pre className="whitespace-pre-wrap break-words">
                      {details.destinationDetails.restAPIDestinationResponseSchema}
                    </pre>
                  </div>
                </div>
              </>
            }

            {details && details.mappingDetails &&
              <>
                <div className="flex py-1">
                  <div className="w-1/5 py-2 font-bold">
                    Data Mapping:
                  </div>
                  <div className="w-2/5 rounded-md bg-gray-100 p-2 text-gray-900">
                    <pre className="whitespace-pre-wrap break-words">
                      {JSON.stringify(details.mappingDetails, null, 2)}
                    </pre>
                  </div>
                </div>
              </>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrationReviewDetails;
